// extracted by mini-css-extract-plugin
export default {"calendar_":"style_calendar___FgiO1","closeButton":"style_closeButton__9f4B1","close":"style_close__jmziT","btnCard":"style_btnCard__FQLLB","btnTxt":"style_btnTxt__xbx0K"};